import styled, { css } from 'styled-components';
import IconCheck from './media/icon-check.svg';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v3.colors.neutral[100]};
    border-radius: 16px;  
    font-family: ${theme.v3.font.family.brand};
    margin: 0 24px;
    overflow: hidden;
    padding: 0 48px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      border-radius: 0;
      margin: 0;
      padding: 0 20px;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    margin: 0 auto;
    max-width: 1550px;
    padding: 96px 0 48px;
    position: relative;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 32px 0;
    }
  `}
`;

export const ShapeBlue = styled.div`
  ${({ theme }) => css`
    background: rgba(210, 228, 255, 0.50);
    border-radius: 992px;
    filter: blur(87px);
    height: 708px;
    position: absolute;
    right: -126px;
    top: 10px;
    width: 687px;

    @media (max-width: ${theme.v3.breakpoints.md}) {  
      display: none;
    }
  `}
`;

export const ShapeGreen = styled.div`
  ${({ theme }) => css`
    background: rgba(109, 222, 118, 0.20);
    border-radius: 1006px;
    filter: blur(162px);
    height: 1006px;
    position: absolute;
    right: -114px;
    top: 780px;
    width: 687px;

    @media (max-width: ${theme.v3.breakpoints.md}) {  
      display: none;
    }
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    padding-right: 0;
    position: relative;
    
    @media (min-width: ${theme.v3.breakpoints.md}) {
      padding-right: 350px;
    }

    @media (min-width: ${theme.v3.breakpoints.lg}) {
      padding-right: 570px;
    }
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    font-size: 40px;
    font-weight: 500;
    margin: 0;

    span {
      color: ${theme.v3.colors.brand.snappyBlue[50]};
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: 24px;
    }
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    color: #535862;
    font-size: 20px;
    font-weight: 400;
    line-height: 1.5;
    margin: 16px 0 32px;
    max-width: 798px;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: 16px;
      margin: 16px 0 40px;
    }
  `}
`;

export const SnappyImage = styled.img`
  ${({ theme }) => css`
    position: absolute;
    right: -24px;
    top: -37px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      display: none;
    }

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      width: 350px;
    }
  `}
`;

export const WrapperHighlights = styled.div`
  ${({ theme }) => css`
    margin-right: -32px;
    position: relative;

    @media (min-width: ${theme.v3.breakpoints.md}) {
      background-color: ${theme.v3.colors.neutral[100]};
      border: 1px solid ${theme.v3.colors.brand.snappyBlue[95]};
      border-radius: 24px;
      max-width: 988px;
      margin-right: 0;
      padding: 24px 0;
    }
  `}
`;

export const Highlight = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin: 0;
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      gap: 12px;
      padding-right: 32px;
    }
  `}
`;

export const HighlightItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.quarck};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      border: 1px solid ${theme.v3.colors.brand.snappyBlue[90]};
      border-radius: 16px;
      min-width: 80vw;
      padding: 24px 16px;
    }

    @media (min-width: ${theme.v3.breakpoints.md}) {
      flex: 1;
      min-height: 190px;
      padding: 0 24px;

      + ${HighlightItem} {
        border-left: 1px solid ${theme.v3.colors.brand.snappyBlue[90]};
      }
    }
  `}
`;

export const HighlightItemIcon = styled.img`
  width: 40px;
  height: 40px;
  margin: 0 0 8px;
`;

export const HighlightItemTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: 18px;
    font-weight: 500;
    margin: 0;
  `}
`;

export const HighlightItemDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[30]};
    font-size: 16px;
    font-weight: 400;
    margin: 16px 0 0;
  `}
`;

export const WrapperFields = styled.div`
  counter-reset: field-row;
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: relative;
  margin-top: 40px;
`;

export const FieldRow = styled.div`
  counter-increment: field-row;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0;
`;

export const FieldLabel = styled.label`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    display: flex;
    font-size: 20px;
    font-weight: 500;
    gap: 8px;
    margin: 0;

    &::before {
      background-color: ${theme.v3.colors.brand.snappyBlue[95]};
      border-radius: 24px;
      content: counter(field-row);
      color: ${theme.v3.colors.neutral[15]};
      font-size: 14px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      width: 24px;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: 16px;
    }
  `}
`;

export const ToggleWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`;

export const ToggleLabel = styled.label`
  color: #535862;
  font-size: 16px;
`;

export const WrapperSelectField = styled.div`
  ${({ theme }) => css`
    width: 100%;
    
    @media (min-width: ${theme.v3.breakpoints.md}) {
      width: 484px;
    }
  `}
`;

export const WrapperOptionsPlan = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 8px;
  position: relative;
`;

export const OptionPlan = styled.div`
  ${({ theme, active }) => css`
    align-items: center;
    border: 1px solid ${theme.v3.colors.brand.snappyBlue[95]};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    gap: 4px;
    padding: 8px 16px;

    ${active && css`
      background-color: ${theme.v3.colors.brand.snappyBlue[98]};
      border-color: ${theme.v3.colors.brand.snappyBlue[98]};
    `}
  `}
`;

export const OptionPlanIcon = styled.div`
  ${({ theme, active }) => css`
    border: 1px solid${theme.v3.colors.neutral[70]};
    border-radius: 20px;
    height: 18px;
    margin: 0 2px;
    position: relative;
    width: 18px;

    &::before {
      background-color: transparent;
      border-radius: 10px;
      content: '';
      display: block;
      height: 10px;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
    }

    ${active && css`
      border-color: ${theme.v3.colors.brand.snappyBlue[50]};

      &::before {
        background-color: ${theme.v3.colors.brand.snappyBlue[50]};
      }
    `}
  `}
`;

export const OptionPlanLabel = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: 14px;
    font-weight: 400;
    margin: 0;
  `}
`;

export const WrapperPlans = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 24px;
    margin-top: 48px;
    position: relative;
    
    @media (min-width: ${theme.v3.breakpoints.md}) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    @media (min-width: ${theme.v3.breakpoints.lg}) {
      grid-template-columns: repeat(4, 1fr);
      gap: 32px
    }
  `}
`;

export const PlanCard = styled.div`
  ${({ theme, active }) => css`
    background-color: ${theme.v3.colors.brand.snappyBlue[95]};
    border-radius: 16px;
    padding: 1px;
    box-shadow: 0 4px 8px 0 rgba(223, 226, 235, 0.22), 0 3px 6px 0 rgba(223, 226, 235, 0.16);

    ${active && css`
      background: linear-gradient(90deg, #2E93EE 0%, #5E61CF 99%);
    `}
  `}
`;

export const PlanCardInner = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v3.colors.neutral[100]};
    border-radius: 15px;
    height: 100%;
    position: relative;
  `}
`;

export const PlanCardBadge = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v3.colors.accent.green[70]};
    border-radius: 4px;
    color: ${theme.v3.colors.neutral[100]};
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    padding: 0 8px;
    position: absolute;
    right: 24px;
    top: -12px;
  `}
`;

export const PlanCardHeader = styled.div`
  ${({ theme }) => css`
    padding: 32px;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      padding: 24px 32px;
    }
  `}
`;

export const PlanCardTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[30]};
    font-size: 24px;
    font-weight: 500;
    line-height: 1.3;
    margin: 0 0 16px;
  `}
`;

export const WrapperPrice = styled.div`
  ${({ isLoading }) => css`
    display: flex;
    flex-direction: ${isLoading ? 'column' : 'row'};
    align-items: ${isLoading ? 'flex-start' : 'center'};
    gap: 4px;
  `}
`;

export const ProductSmallText = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[30]};
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
  `}
`;

export const ProductPrice = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: 32px;
    font-weight: 500;
    line-height: 1.3;
  `}
`;

export const ProductPricePerDay = styled.div`
  color: #535862;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 4px;
`;

export const PlanCardCta = styled.div`
  margin-top: 32px;
`;

export const PlanCardBody = styled.div`
  ${({ theme }) => css`
    padding: 32px 32px 40px;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      padding: 24px 24px 40px;
    }
  `}
`;

export const PlanCardHighlights = styled.ul`
  appearance: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  margin: 24px 0 0;
  padding: 0;
`;

export const PlanCardText = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5;
  `}
`;

export const PlanCardHighlightItem = styled.li`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v3.colors.neutral[30]};
    display: flex;
    font-size: 14px;
    line-height: 1.5;
    min-height: 24px;
    padding-left: 36px;
    position: relative;

    &::before {
      background-image: url(${IconCheck});
      background-repeat: no-repeat;
      content: '';
      display: block;
      height: 24px;
      left: 0;
      position: absolute;
      top: 0;
      width: 24px;
    }
  `}
`;

export const PlanCardHighlightText = styled.div``;
